<template>
    <div class="casiola-app-filter-modal">
        <header>
            <h2>Filters</h2>
            <button aria-label="close" @click.stop.prevent="close">
                <i class="fas fa-times"></i>
            </button>
        </header>
        <main>
            <last-minute-filter></last-minute-filter>
            <section>
                <h3>Beds & bathrooms</h3>
                <ul>
                    <li>
                        <label class="type--slider">
                            <span>Beds</span>
                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBeds" :min="1" size="small" inline
                                controls placeholder="0" :inputtable="false"></vue-number-input>
                        </label>
                    </li>
                    <li>
                        <label class="type--slider">
                            <span>Bedrooms</span>
                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBedrooms" :min="1" size="small"
                                inline controls placeholder="0" :inputtable="false"></vue-number-input>
                        </label>
                    </li>
                    <li>
                        <label class="type--slider">
                            <span>Bathrooms</span>
                            <vue-number-input v-model="casiola.state.advancedFilters.minimumBathrooms" :min="1" size="small"
                                inline controls placeholder="0" :inputtable="false"></vue-number-input>
                        </label>
                    </li>
                </ul>
            </section>
            <section>
                <h3>Vacation rental type</h3>
                <ul class="grid">
                    <li v-for="ltype in casiola.state.collections.lodgingTypes" :key="ltype.id">
                        <label class="type--checkbox">
                            <input type="checkbox" v-model="casiola.state.advancedFilters.lodgingTypeIds"
                                name="lodgingTypes" :value="ltype.id" />
                            <span>{{ ltype.name }}</span>
                        </label>
                    </li>
                </ul>
            </section>
            <!-- <section>
                <h3>Resort</h3>
                <ul class="grid">
                    <li v-for="loc in locationsFiltered" :key="loc.id">
                        <label class="type--checkbox">
                            <input type="checkbox" v-model="casiola.state.advancedFilters.locationIds" name="locations"
                                :value="loc.id" />
                            <span>{{ loc.name }}</span>
                        </label>
                    </li>
                </ul>
            </section> -->
            <!-- <amenities-filter v-if="casiola.state.baseFilters.destinations.length"></amenities-filter> -->
            <amenities-filter></amenities-filter>
            <section class="section-toggle privatepool">
                <div class="body">
                    <h3>Pool access</h3>
                    <span>Show properties with access to private pools and resort pools</span>
                </div>
                <toggle v-model="casiola.state.advancedFilters.privatePool"></toggle>
            </section>
            <section class="section-toggle petfriendly">
                <div class="body">
                    <h3>Pet friendly</h3>
                    <span>Show only properties that are pet friendly</span>
                </div>
                <toggle v-model="casiola.state.advancedFilters.petFriendly"></toggle>
            </section>
        </main>
        <footer>
            <button aria-label="clear" @click.stop.prevent="clear">Clear all</button>
            <button aria-label="close" @click.stop.prevent="close">{{ casiola.state.results.total ? `Show ${casiola.state.results.total} vacation rentals` : 'No results found'
            }}</button>
        </footer>
    </div>
</template>
<script>
import { computed } from 'vue'
import { useCasiolaStore } from '@/store'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import Toggle from '@vueform/toggle'
import LastMinuteFilter from '@/components/LastMinuteFilter.vue'
import AmenitiesFilter from '@/components/AmenitiesFilter.vue'

export default {
    components: { VueNumberInput, Toggle, LastMinuteFilter, AmenitiesFilter },
    emits: ['close'],
    setup(props, context) {
        // CASIOLA STORE
        const casiola = useCasiolaStore()

        const locationsFiltered = computed(() => {
            return casiola.state.collections.locations.filter(loc => !casiola.state.baseFilters.destinations.length || casiola.state.baseFilters.destinations.includes(loc.destinationId))
        })

        const clear = () => {
            casiola.state.advancedFilters.deal = null
            casiola.state.advancedFilters.minimumBeds = 1
            casiola.state.advancedFilters.maximumBeds = null
            casiola.state.advancedFilters.minimumBedrooms = 0
            casiola.state.advancedFilters.maximumBedrooms = null
            casiola.state.advancedFilters.minimumBathrooms = 1
            casiola.state.advancedFilters.maximumBathrooms = null
            casiola.state.advancedFilters.lodgingTypeIds = []
            casiola.state.advancedFilters.locationIds = []
            casiola.state.advancedFilters.petFriendly = null
            casiola.state.advancedFilters.privatePool = null
        }

        const close = () => {
            context.emit("close")
        }

        return {
            casiola,
            locationsFiltered,
            clear,
            close
        }
    }
}
</script>
<style lang="scss">
.v-slider {
    &.slider-horizontal .slider-tooltip-bottom {
        transform: translate(-50%, -50%);
    }
}

.casiola-app-filter-modal {
    .vue-number-input--small.vue-number-input--inline>input {
        width: 5rem !important;
    }
}
</style>
<style src="@vueform/toggle/themes/default.css">
</style>